import script from "./Fact.vue?vue&type=script&setup=true&lang=ts"
export * from "./Fact.vue?vue&type=script&setup=true&lang=ts"

import "./Fact.vue?vue&type=style&index=0&id=525d391f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525d391f"]])

export default __exports__